// GroupPage.js
import React, { useEffect, useState } from "react";
import { getDatabase, ref, onValue, set, get } from "firebase/database";
import { getAuth } from "firebase/auth";

function GroupPage() {
  const [devices, setDevices] = useState([]);
  const [groups, setGroups] = useState({});
  const [groupNames, setGroupNames] = useState({});
  const [loading, setLoading] = useState(true);
  const [selectedDevice, setSelectedDevice] = useState(null);
  const [newGroup, setNewGroup] = useState("");
  const [showModal, setShowModal] = useState(false);
  const [errorMsg, setErrorMsg] = useState("");
  const [searchTerm, setSearchTerm] = useState("");
  const [statusFilter, setStatusFilter] = useState("สถานะ");
  const [showGroupManager, setShowGroupManager] = useState(false);
  const [groupStats, setGroupStats] = useState([]);
  const [userInfo, setUserInfo] = useState({});


  const auth = getAuth();
  const db = getDatabase();

  const [deviceInfo, setDeviceInfo] = useState(null);
  const [showEditModal, setShowEditModal] = useState(false);
  const [editFields, setEditFields] = useState({
    userName: "",
    userNumber: "",
    userEmail: "",
    userAddress: ""
  });

  const [visibleCols, setVisibleCols] = useState({
    userName: false,
    userNumber: false,
    userEmail: false,
    userAddress: false,
    versionUpdatedAt: true,
  });

  const updateGroupFlag = async (groupName) => {
    const flagRef = ref(db, `update_flags_by_group/${groupName}`);
    await set(flagRef, {
      updated_at: Date.now()
    });
  };
  
  useEffect(() => {
    const shouldLoad = Object.values(visibleCols).some(Boolean);
    if (!shouldLoad) return;
  
    const loadAllUserInfo = async () => {
      const membersRef = ref(db, `esp32_members`);
      const snapshot = await get(membersRef);
      if (snapshot.exists()) {
        const data = snapshot.val();
        const merged = {};
        for (const group in data) {
          for (const shortID in data[group]) {
            merged[shortID] = data[group][shortID];
          }
        }
        setUserInfo(merged);
      }
    };
  
    loadAllUserInfo();
  }, [visibleCols]);
  

  useEffect(() => {
    const unsubscribe = auth.onAuthStateChanged((user) => {
      if (user) {
        const uid = user.uid;
        const mapRef = ref(db, `user_esp32_map/${uid}`);
        const groupRef = ref(db, `esp32_index`);
        const groupNameRef = ref(db, `group_name`);

        onValue(mapRef, (snapshot) => {
          const data = snapshot.val();
          if (data) {
            const shortIDs = Object.keys(data);
            setDevices(shortIDs);

            Promise.all([get(groupNameRef), get(groupRef)]).then(([nameSnap, indexSnap]) => {
              const groupNameData = nameSnap.exists() ? nameSnap.val() : {};
              const groupIndexData = indexSnap.exists() ? indexSnap.val() : {};

              setGroupNames(groupNameData);
              setGroups(groupIndexData);
              setLoading(false);

              const allGroupNames = Object.entries(groupNameData)
                .filter(([_, ownerUid]) => ownerUid === uid)
                .map(([name]) => name);
              const activeGroups = Object.values(groupIndexData);
              const unusedGroups = allGroupNames.filter(name => !activeGroups.includes(name));

              
            });
          } else {
            setDevices([]);
            setLoading(false);
          }
        });
      } else {
        setDevices([]);
        setLoading(false);
      }
    });

    return () => unsubscribe();
  }, []);

  const handleGroupEdit = (id) => {
    setSelectedDevice(id);
    setNewGroup(groups[id] && groups[id] !== "none" ? groups[id] : "");
    setErrorMsg("");
    setShowModal(true);
  };

  const reloadGroupStats = async () => {
    const groupNameSnap = await get(ref(db, "group_name"));
    const groupIndexSnap = await get(ref(db, "esp32_index"));
  
    const groupNames = groupNameSnap.exists() ? Object.keys(groupNameSnap.val()) : [];
    const indexData = groupIndexSnap.exists() ? Object.values(groupIndexSnap.val()) : [];
  
    const stats = groupNames.map(name => {
      const count = indexData.filter(group => group === name).length;
      return { name, count };
    });
  
    setGroupStats(stats);
  };
  


  const handleSaveGroup = async () => {
    const uid = auth.currentUser?.uid;
    if (!uid || !selectedDevice) return;
  
    const trimmedGroup = newGroup.trim();
    if (!trimmedGroup) return;
  
    const groupCheckRef = ref(db, `group_name/${trimmedGroup}`);
    const groupSnapshot = await get(groupCheckRef);
  
    if (groupSnapshot.exists() && groupSnapshot.val() !== uid) {
      setErrorMsg("ชื่อกลุ่มนี้ถูกใช้งานแล้วโดยผู้ใช้รายอื่น กรุณาใช้ชื่ออื่น");
      return;
    }
  
    const userMapRef = ref(db, `user_esp32_map/${uid}`);
    const allGroupNameSnap = await get(ref(db, "group_name"));
    const allGroups = allGroupNameSnap.exists() ? allGroupNameSnap.val() : {};
    const userGroups = Object.values(allGroups).filter(v => v === uid).length;
  
    const userMapSnap = await get(userMapRef);
    const deviceCount = userMapSnap.exists() ? Object.keys(userMapSnap.val()).length : 0;
    const maxGroups = Math.max(1, Math.floor(deviceCount / 2));
  
    if (!groupSnapshot.exists() && userGroups >= maxGroups) {
      setErrorMsg(`คุณสามารถสร้างได้ไม่เกิน ${maxGroups} กลุ่ม กรุณาลบกลุ่มที่ไม่ได้ใช้งานก่อน`);
      return;
    }
  
    await set(ref(db, `esp32_index/${selectedDevice}`), trimmedGroup);
    await set(groupCheckRef, uid);
  
    setGroupNames((prev) => ({
      ...prev,
      [trimmedGroup]: uid
    }));
  
    await reloadGroupStats();
  
    const membersRef = ref(db, `esp32_members`);
    const membersSnapshot = await get(membersRef);
  
    let oldGroup = null; // ✅ ย้ายมานอก if
  
    if (membersSnapshot.exists()) {
      const membersData = membersSnapshot.val();
  
      for (const groupName in membersData) {
        if (membersData[groupName] && membersData[groupName][selectedDevice]) {
          oldGroup = groupName;
          break;
        }
      }
  
      if (oldGroup) {
        const deviceData = membersData[oldGroup][selectedDevice];
        await set(ref(db, `esp32_members/${oldGroup}/${selectedDevice}`), null);
        await set(ref(db, `esp32_members/${trimmedGroup}/${selectedDevice}`), deviceData);
      }
    }
  
    setGroups((prev) => ({
      ...prev,
      [selectedDevice]: trimmedGroup
    }));
  
    setShowModal(false);
  
    // ✅ อัปเดตเฉพาะกลุ่มเดิมเท่านั้น
    if (oldGroup && oldGroup !== trimmedGroup) {
      await updateGroupFlag(oldGroup);
    }
  };
  

  const handleSaveDeviceInfo = async () => {
    if (!deviceInfo) return;
    const { group, shortID } = deviceInfo;
    const updateRef = ref(db, `esp32_members/${group}/${shortID}`);
    await set(updateRef, {
      ...(await (await get(updateRef)).val()),
      ...editFields
    });
    setShowEditModal(false);
  }; 

// แปลง timestamp เป็นสีตามเงื่อนไข



const getStatusColor = (dateStr) => {
  if (!dateStr) return { color: "gray", label: "-", type: "unknown" };

  const updatedDate = new Date(dateStr.replace(" ", "T"));
  const now = new Date();

  // แปลงเป็น "วันที่ไม่สนเวลา"
  const updatedYMD = new Date(updatedDate.getFullYear(), updatedDate.getMonth(), updatedDate.getDate());
  const nowYMD = new Date(now.getFullYear(), now.getMonth(), now.getDate());

  const diffTime = nowYMD - updatedYMD;
  const diffDays = diffTime / (1000 * 60 * 60 * 24);

  if (diffDays === 0) return { color: "green", label: dateStr, type: "วันนี้" };
  if (diffDays > 0 && diffDays <= 3) return { color: "orange", label: dateStr, type: "3วัน" };
  return { color: "red", label: dateStr, type: "เกิน3วัน" };
};


const filteredDevices = devices.filter((id) => {
  const term = searchTerm.toLowerCase();
  const group = groups[id] || "A0";
  const info = userInfo[id] || {};

  const matchSearch =
    id.toLowerCase().includes(term) ||
    group.toLowerCase().includes(term) ||
    (visibleCols.userName && info.userName?.toLowerCase().includes(term)) ||
    (visibleCols.userEmail && info.userEmail?.toLowerCase().includes(term)) ||
    (visibleCols.userNumber && info.userNumber?.toLowerCase().includes(term)) ||
    (visibleCols.userAddress && info.userAddress?.toLowerCase().includes(term));

  // ✅ ตรวจสอบสถานะจาก getStatusColor()
  const status = getStatusColor(info.versionUpdatedAt).type;

  const matchStatus =
    statusFilter === "สถานะ" || // แสดงทั้งหมด
    status === statusFilter;

  return matchSearch && matchStatus;
});


  const handleEditDeviceInfo = async (shortID) => {
    const membersRef = ref(db, `esp32_members`);
    const snapshot = await get(membersRef);

    if (snapshot.exists()) {
      const data = snapshot.val();
      for (const group in data) {
        if (data[group][shortID]) {
          const info = data[group][shortID];
        
          // บันทึกลง userInfo
          setUserInfo(prev => ({ ...prev, [shortID]: info }));
        
          // ใช้สำหรับ modal
          setDeviceInfo({ group, shortID });
          setEditFields({
            userName: info.userName || "",
            userNumber: info.userNumber || "",
            userEmail: info.userEmail || "",
            userAddress: info.userAddress || ""
          });
          setShowEditModal(true);
        }
        
      }
    }
  };

  const handleOpenGroupManager = async () => {
    const groupNameSnap = await get(ref(db, "group_name"));
    const groupIndexSnap = await get(ref(db, "esp32_index"));

    const groupNames = groupNameSnap.exists() ? Object.keys(groupNameSnap.val()) : [];
    const indexData = groupIndexSnap.exists() ? Object.values(groupIndexSnap.val()) : [];

    const stats = groupNames.map(name => {
      const count = indexData.filter(group => group === name).length;
      return { name, count };
    });

    setGroupStats(stats);
    setShowGroupManager(true);
  };

  
  const handleDeleteGroup = async (groupName) => {
    // ลบ group_name
    await set(ref(db, `group_name/${groupName}`), null);
  
    // ลบสมาชิกกลุ่ม (ถ้ามี)
    await set(ref(db, `esp32_members/${groupName}`), null);
  
    // รีโหลด groupStats ใหม่ เพื่ออัปเดต UI ทันที
    await reloadGroupStats();
  
    // อัปเดต groupNames ใน local state ด้วย
    setGroupNames(prev => {
      const updated = { ...prev };
      delete updated[groupName];
      return updated;
    });

    await updateGroupFlag(groupName);
  };
  

  if (loading) return <p className="text-center mt-4">Loading...</p>;

  return (
    <div className="container mt-5">
      <div className="card shadow-lg">
        <div className="card-body">

        <div className="d-flex justify-content-between align-items-center mb-3">
            {/* ปุ่มอยู่ฝั่งซ้าย */}
            <button className="btn btn-success" onClick={handleOpenGroupManager}>
              จัดการกลุ่ม
            </button>

            {/* ช่องค้นหาอยู่ฝั่งขวา */}
            <input
              type="text"
              className="form-control w-auto"
              style={{ minWidth: "250px", maxWidth: "400px" }}
              placeholder="ค้นหา"
              value={searchTerm}
              onChange={(e) => setSearchTerm(e.target.value)}
            />
        </div>


        {/* ✅ Checkbox แสดง/ซ่อน column */}
        <div className="d-flex flex-wrap justify-content-center gap-3 mb-3">
          <label>
            <input
              type="checkbox"
              checked={visibleCols.userName}
              onChange={() =>
                setVisibleCols({ ...visibleCols, userName: !visibleCols.userName })
              }
            />{" "}
            ชื่อผู้ใช้
          </label>
          <label>
            <input
              type="checkbox"
              checked={visibleCols.userEmail}
              onChange={() =>
                setVisibleCols({ ...visibleCols, userEmail: !visibleCols.userEmail })
              }
            />{" "}
            อีเมล
          </label>
          <label>
            <input
              type="checkbox"
              checked={visibleCols.userNumber}
              onChange={() =>
                setVisibleCols({ ...visibleCols, userNumber: !visibleCols.userNumber })
              }
            />{" "}
            เบอร์โทร
          </label>
          <label>
            <input
              type="checkbox"
              checked={visibleCols.userAddress}
              onChange={() =>
                setVisibleCols({ ...visibleCols, userAddress: !visibleCols.userAddress })
              }
            />{" "}
            ที่อยู่
          </label>
          <label>
            <input
              type="checkbox"
              checked={visibleCols.versionUpdatedAt}
              onChange={() =>
                setVisibleCols({
                  ...visibleCols,
                  versionUpdatedAt: !visibleCols.versionUpdatedAt,
                })
              }
            />{" "}
            สถานะ
          </label>

        </div>
        <div style={{ overflowX: "auto" }}>
          <table
            className="table table-bordered table-hover table-striped"
            style={{ minWidth: "100%", width: "max-content", whiteSpace: "nowrap" }}
          >
                    <thead className="thead-dark">
                      <tr>
                        <th>🔑 รหัสเครื่อง (Short ID)</th>
                        <th>👥 กลุ่ม</th>

                        {visibleCols.userName && <th>ชื่อผู้ใช้</th>}
                        {visibleCols.userEmail && <th>อีเมล</th>}
                        {visibleCols.userNumber && <th>เบอร์โทร</th>}
                        {visibleCols.userAddress && <th>ที่อยู่</th>}
                        
                        {visibleCols.versionUpdatedAt && (
                          <th>
                            <select
                              className="form-select form-select-sm"
                              value={statusFilter}
                              onChange={(e) => setStatusFilter(e.target.value)}
                              style={{ fontWeight: "bold", textAlign: "center" }}
                            >
                              <option value="สถานะ">สถานะ</option>
                              <option value="วันนี้">วันนี้</option>
                              <option value="3วัน">3 วัน</option>
                              <option value="เกิน3วัน">เกิน 3 วัน</option>
                            </select>
                          </th>
                        )}

                      </tr>
                    </thead>

                    <tbody>
                      {filteredDevices.map((id) => (
                        <tr key={id}>
                          <td style={{ cursor: "pointer" }} onClick={() => handleEditDeviceInfo(id)}>
                            {id}
                          </td>
                          <td
                            style={{ cursor: "pointer", color: groups[id] === "A0" ? "red" : "inherit" }}
                            onClick={() => handleGroupEdit(id)}
                          >
                            {groups[id] === "A0" ? "ยังไม่อยู่ในกลุ่ม" : groups[id]}
                          </td>

                          {visibleCols.userName && <td>{userInfo[id]?.userName || "-"}</td>}
                          {visibleCols.userEmail && <td>{userInfo[id]?.userEmail || "-"}</td>}
                          {visibleCols.userNumber && <td>{userInfo[id]?.userNumber || "-"}</td>}
                          {visibleCols.userAddress && <td>{userInfo[id]?.userAddress || "-"}</td>}
                          {visibleCols.versionUpdatedAt && (
                            <td
                              style={{
                                color: getStatusColor(userInfo[id]?.versionUpdatedAt).color,
                                fontWeight: "bold",
                              }}
                            >
                              {getStatusColor(userInfo[id]?.versionUpdatedAt).label}
                            </td>
                          )}


                        </tr>
                      ))}
                    </tbody>
          </table>
              {devices.length === 0 && (
                <div className="text-center text-muted">ยังไม่มีอุปกรณ์ที่ผูกไว้</div>
              )}
        </div>
        </div>
      </div>

      {showModal && (
        <div className="modal fade show d-block" tabIndex="-1" style={{ backgroundColor: 'rgba(0,0,0,0.5)' }}>
          <div className="modal-dialog">
            <div className="modal-content">
              <div className="modal-header">
                <h5 className="modal-title">กำหนดกลุ่มสำหรับ: {selectedDevice}</h5>
                <button type="button" className="btn-close" onClick={() => setShowModal(false)}></button>
              </div>
              <div className="modal-body">
                <select className="form-select mb-2" value={newGroup} onChange={(e) => setNewGroup(e.target.value)}>
                  <option value="">-- เลือกกลุ่มที่มี หรือพิมพ์ใหม่ --</option>
                  {Object.keys(groupNames).map((name) => (
                    <option key={name} value={name}>{name}</option>
                  ))}
                </select>
                <input
                  type="text"
                  className="form-control"
                  placeholder="หรือพิมพ์ชื่อกลุ่มใหม่ เช่น A1, B2"
                  value={newGroup}
                  onChange={(e) => setNewGroup(e.target.value)}
                />
                {errorMsg && <div className="text-danger mt-2">{errorMsg}</div>}
              </div>
              <div className="modal-footer">
                <button className="btn btn-secondary" onClick={() => setShowModal(false)}>ยกเลิก</button>
                <button className="btn btn-primary" onClick={handleSaveGroup}>บันทึก</button>
              </div>
            </div>
          </div>
        </div>
      )}
      
      {showEditModal && (
        <div className="modal fade show d-block" tabIndex="-1" style={{ backgroundColor: 'rgba(0,0,0,0.5)' }}>
          <div className="modal-dialog">
            <div className="modal-content">
              <div className="modal-header">
                <h5 className="modal-title">แก้ไขข้อมูลผู้ใช้ของ: {deviceInfo.shortID}</h5>
                <button type="button" className="btn-close" onClick={() => setShowEditModal(false)}></button>
              </div>
              <div className="modal-body">
                <input className="form-control mb-2" placeholder="ชื่อผู้ใช้" value={editFields.userName} onChange={(e) => setEditFields({ ...editFields, userName: e.target.value })} />
                <input className="form-control mb-2" placeholder="เบอร์โทร" value={editFields.userNumber} onChange={(e) => setEditFields({ ...editFields, userNumber: e.target.value })} />
                <input className="form-control mb-2" placeholder="อีเมล" value={editFields.userEmail} onChange={(e) => setEditFields({ ...editFields, userEmail: e.target.value })} />
                <input className="form-control mb-2" placeholder="ที่อยู่" value={editFields.userAddress} onChange={(e) => setEditFields({ ...editFields, userAddress: e.target.value })} />
              </div>
              <div className="modal-footer">
             
                <button className="btn btn-secondary" onClick={() => setShowEditModal(false)}>ยกเลิก</button>
                <button className="btn btn-primary" onClick={handleSaveDeviceInfo}>บันทึก</button>
              </div>
            </div>
          </div>
        </div>
      )}

      {showGroupManager && (
          <div className="modal fade show d-block" tabIndex="-1" style={{ backgroundColor: 'rgba(0,0,0,0.5)' }}>
            <div className="modal-dialog">
              <div className="modal-content">
                <div className="modal-header">
                  <h5 className="modal-title">จัดการกลุ่มของคุณ</h5>
                  <button type="button" className="btn-close" onClick={() => setShowGroupManager(false)}></button>
                </div>
                <div className="modal-body">
                  <table className="table table-bordered">
                    <thead>
                      <tr>
                        <th>ชื่อกลุ่ม</th>
                        <th>จำนวนสมาชิก</th>
                        <th>ลบ</th>
                      </tr>
                    </thead>
                    <tbody>
                      {groupStats.map(({ name, count }) => (
                        <tr key={name}>
                          <td>{name}</td>
                          <td>{count}</td>
                          <td>
                            {count === 0 ? (
                              <button className="btn btn-danger btn-sm" onClick={() => handleDeleteGroup(name)}>
                                ลบ
                              </button>
                            ) : (
                              <span className="text-muted">-</span>
                            )}
                          </td>
                        </tr>
                      ))}
                      {groupStats.length === 0 && (
                        <tr><td colSpan="3" className="text-center text-muted">ยังไม่มีกลุ่ม</td></tr>
                      )}
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
          </div>
        )}
    </div>
  );
}

export default GroupPage;
